import { urls } from '../constants/app';
import request from './utils/request';
import { setError, resetError } from './errors';
import moment from 'moment';

function syncNotificationPreferences(dispatch, data) {
    const prefs = {};
    if (data.sseEnabled !== undefined) prefs.sseEnabled = data.sseEnabled;
    if (data.autoRefreshEnabled !== undefined) prefs.autoRefreshEnabled = data.autoRefreshEnabled;
    if (data.autoRefreshInterval !== undefined) prefs.autoRefreshInterval = data.autoRefreshInterval;
    if (Object.keys(prefs).length > 0) {
        dispatch({ type: 'SET_NOTIFICATION_PREFERENCES', preferences: prefs });
    }
}

export function fetchSettings(withoutLoader) {
    return dispatch => {
        if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'settings', value: true });

        return request({ method: 'get', url: `${urls.settings}`, params: { isCrm: true } })
            .then((response) => {
                const data = response.length ? response[0] : {};
                dispatch({ type: 'SET_SETTINGS', data });
                syncNotificationPreferences(dispatch, data);
                if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'settings', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError(error, 'settings'));
                if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'settings', value: false });
                return null
            });
        
    }
}

export function updateSettings(data) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'settings', value: true });
        dispatch(resetError('settings'));
        return request({ method: 'put', url: `${urls.settings}/1`, data })
            .then((response) => {
                const resData = response ? response : {};
                dispatch({ type: 'SET_SETTINGS', data: resData });
                syncNotificationPreferences(dispatch, resData);
                dispatch({ type: 'SET_LOADER', field: 'settings', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'settings'));
                dispatch({ type: 'SET_LOADER', field: 'settings', value: false });
                return null
            });
        
    }
}

export function setEditedSettings(field, value) {
    return dispatch => {
        dispatch({ type: 'SET_EDITED_SETTINGS', field, value });
    }
}

// promocode actions

export function setPromocodePaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_PROMOCODES_PAGING', paging });
    }
}

export function fetchPromocodes(getAll = false) {
    return (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'promocodes', value: true });

    const paging = getState().promocodes.paging;
    const sorting = getState().promocodes.sorting;
    const filters = getState().promocodes.filters;

    const params = { isCrm: true };
    const dataParams = {};

    params.source = 'marketing';
    if (!getAll) {
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
    } else {
        params['_start'] = 0;
        params['_limit'] = -1;
    }

    params['_sort'] = `${sorting.field}:${sorting.type}`;

    if (filters.city) {
        dataParams['city.id'] = filters.city.value;
        params['city.id'] = filters.city.value;
    }

    if (filters.startDate) {
        dataParams['startDate_gte'] = moment(filters.startDate).format('YYYY-MM-DD HH:mm:ss');
        params['startDate_gte'] = moment(filters.startDate).format('YYYY-MM-DD HH:mm:ss');
    }

    if (filters.endDate) {
        dataParams['endDate_lte'] = moment(filters.endDate).format('YYYY-MM-DD HH:mm:ss');
        params['endDate_lte'] = moment(filters.endDate).format('YYYY-MM-DD HH:mm:ss');
    }

    const isReusableTab = filters.mainType === 'reusable';

    if (filters.mainType === 'disposable') {
        dataParams.mainType = 'disposable';
        params.mainType = 'disposable';
    }

    if (isReusableTab) {
        const reusableParams = {
            ...params,
            _start: 0,
            _limit: -1
        };

        request({ method: 'get', url: urls.promocodes, params: reusableParams })
            .then((response) => {
                const reusablePromocodes = response.filter((item) => item.mainType !== 'disposable');
                const currentPromocodes = getAll
                    ? reusablePromocodes
                    : reusablePromocodes.slice(paging.start, paging.start + paging.limit);

                const promocodes = currentPromocodes.map(item => {
                    return ({
                        ...item,
                        city: item.city ? { value: item.city.id, label: item.city.name } : null
                    });
                });

                dispatch({ type: 'SET_PROMOCODES_COUNT', count: reusablePromocodes.length });
                dispatch({ type: 'SET_PROMOCODES', promocodes });
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
            })
            .catch(error => {
                dispatch(setError(error, 'promocodes'));
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
            });
        return;
    }

    request({ method: 'get', url:  urls.promocodes+'/count', params: dataParams })
        .then(result => {
            dispatch({ type: 'SET_PROMOCODES_COUNT', count: result });
            return;
        }).then(() => {
            return request({ method: 'get', url: urls.promocodes, params }).then((response) => {
                const promocodes = response.map(item => {
                    return ({
                        ...item,
                        city: item.city ? { value: item.city.id, label: item.city.name } : null
                    });
                })
                dispatch({ type: 'SET_PROMOCODES', promocodes });
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
            });
        })
        .catch(error => {
            dispatch(setError(error, 'promocodes'));
            dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
        });
    }
}

export function setEditedPromocode(promocode) {
    return { type: 'SET_EDITED_PROMOCODE', promocode }
}

export function setDetailPromocode(promocode) {
    return { type: 'SET_PROMOCODE', promocode }
}

export function setPromocodeFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_PROMOCODES_FILTERS', filters });
    }
}

export function setDeletePromocode(promocode) {
    return { type: 'SET_DELETE_PROMOCODE', promocode }
}

export function updatePromocode(id, data) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'promocodes', value: true });
        dispatch(resetError('promocodes'));

        const updatedData = { ...data };
        const cities = data.cities.map(item => item.value || item.id);
        updatedData.cities = cities;
        updatedData.city = cities[0] || null;

        return request({ method: 'put', url: `${urls.promocodes}/${id}`, data: updatedData })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'promocodes'));
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
                return null
            });
        
    }
}

export function setAddPromocode(promocode) {
    return { type: 'SET_ADD_PROMOCODE', promocode }
}

export function addPromocode(data) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'promocodes', value: true });
        dispatch(resetError('promocodes'));
        const updatedData = { ...data };
        const cities = data.cities.map(item => item.value || item.id);
        updatedData.cities = cities;
        updatedData.city = cities[0] || null;

        return request({ method: 'post', url: `${urls.promocodes}`, data: updatedData })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError({ status: 506 }, 'promocodes'));
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
                return null
            });
        
    }
}

export function deletePromocode(id) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'promocodes', value: true });
        dispatch(resetError('promocodes'));
        return request({ method: 'delete', url: `${urls.promocodes}/${id}` })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'promocodes'));
                dispatch({ type: 'SET_LOADER', field: 'promocodes', value: false });
                return null
            });
        
    }
}

// promotion actions

export function setPromotionsPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_PROMOTIONS_PAGING', paging });
    }
}

export function fetchPromotions(source, isNewOrder) {
    return (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'promotions', value: true });
    const params = {};
    const dataParams = {};

    if (!isNewOrder) {
        const paging = getState().promotions.paging;
        const sorting = getState().promotions.sorting;
        const filters = getState().promotions.filters;
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;

        params['_sort'] = `${sorting.field}:${sorting.type}`;

        if (filters.city) {
            dataParams['city.id'] = filters.city.value;
            params['city.id'] = filters.city.value;
        }

        if (filters.startDate) {
            dataParams['startDate_gte'] = moment(filters.startDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
            params['startDate_gte'] = moment(filters.startDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        }

        if (filters.endDate) {
            dataParams['endDate_lte'] = moment(filters.endDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
            params['endDate_lte'] = moment(filters.endDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        }
    } else {
        params.active = true;
    }
    
    params.source = source;
    

    request({ method: 'get', url:  urls.promotion+'/count', params: dataParams })
        .then(result => {
            dispatch({ type: 'SET_PROMOTIONS_COUNT', count: result });
            return;
        }).then(() => {
            return request({ method: 'get', url: urls.promotion, params }).then((response) => {
                const promotions = response.map(item => {
                    return ({
                        ...item,
                        city: item.city ? { value: item.city.id, label: item.city.name } : null
                    });
                })
                dispatch({ type: 'SET_PROMOTIONS', promotions });
                dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
            });
        })
        .catch(error => {
            dispatch(setError(error, 'promotions'));
            dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
        });
    }
}

export function setEditedPromotion(promotion) {
    return { type: 'SET_EDITED_PROMOTION', promotion }
}

export function setDetailPromotion(promotion) {
    return { type: 'SET_PROMOTION', promotion }
}

export function setPromotionsFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_PROMOTIONS_FILTERS', filters });
    }
}

export function setDeletePromotion(promotion) {
    return { type: 'SET_DELETE_PROMOTION', promotion }
}

export function updatePromotion(id, data) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'promotions', value: true });
        dispatch(resetError('promotions'));

        const updatedData = { ...data };
        const cities = data.cities.map(item => item.value || item.id);
        updatedData.cities = cities;
        updatedData.city = cities[0] || null;

        return request({ method: 'put', url: `${urls.promotion}/${id}`, data: updatedData })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'promotions'));
                dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
                return null
            });
        
    }
}

export function setAddPromotion(promotion) {
    return { type: 'SET_ADD_PROMOTION', promotion }
}

export function addPromotion(data) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'promotions', value: true });
        dispatch(resetError('promotions'));
        const updatedData = { ...data };
        const cities = data.cities.map(item => item.value || item.id);
        updatedData.cities = cities;
        updatedData.city = cities[0] || null;

        return request({ method: 'post', url: `${urls.promotion}`, data: updatedData })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError({ status: 506 }, 'promotions'));
                dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
                return null
            });
        
    }
}

export function deletePromotion(id) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'promotions', value: true });
        dispatch(resetError('promotions'));
        return request({ method: 'delete', url: `${urls.promotion}/${id}` })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'promotions'));
                dispatch({ type: 'SET_LOADER', field: 'promotions', value: false });
                return null
            });
        
    }
}